import * as z from "zod";

import { compareNaturalText } from "@/lib/compare-natural-text";

export const LabelSchema = z.object({
  id: z.string(),
  title: z.string(),
  color: z.string(),
  workspaceId: z.string(),
  labelGroupId: z.string().optional().nullable(),
});
export type Label = z.infer<typeof LabelSchema>;

export const sortLabel = (
  a?: Label | null | undefined,
  b?: Label | null | undefined,
  desc: boolean = false,
): 0 | 1 | -1 => {
  if (!a && !b) {
    return 0;
  }

  if (!a) {
    return desc ? 1 : -1;
  }

  if (!b) {
    return desc ? -1 : 1;
  }

  const orderKey = compareNaturalText(a.title, b.title);

  if (desc) {
    return orderKey > 0 ? -1 : 1;
  }

  return orderKey > 0 ? 1 : -1;
};
